import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1920f1ac&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1920f1ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1920f1ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1920f1ac')) {
      api.createRecord('1920f1ac', component.options)
    } else {
      api.reload('1920f1ac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1920f1ac&scoped=true&", function () {
      api.rerender('1920f1ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/merchant/index.vue"
export default component.exports